import { CodeMap, CodeMapCategory, CodeMapTokenWithLocate } from 'adminConsole/page'
import { codeMapStore as codeMapStoreFromAdming } from 'adminConsole/store'
import { codeMapStore as codeMapStoreFromMobile } from 'mobileApp/store'
import { ErrorData } from 'mobileApp/system/model/common'

export const getCodeMapOptions = (
  data: CodeMap[],
  category: string,
  isFilterEnable?: boolean,
  reserve1Name?: string,
  order: 'asc' | 'desc' = 'asc'
) =>
  data
    .filter(codeMap => codeMap.category === category)
    .filter(codeMap => (isFilterEnable ? codeMap.enable === true : true))
    .filter(codeMap => (reserve1Name && codeMap.reserve1 ? codeMap.reserve1?.split(',').includes(reserve1Name) : true))
    .sort((a, b) =>
      order === 'asc' ? (a.precedence ?? 0) - (b.precedence ?? 0) : (b.precedence ?? 0) - (a.precedence ?? 0)
    )
    .map(codeMap => ({ label: codeMap.name ?? '', value: codeMap.value ?? '' }))

export const useCodeMapValueToName = ({ locateAt }: { locateAt: CodeMapTokenWithLocate }) => {
  const codeMapList =
    locateAt === CodeMapTokenWithLocate.Admin ? codeMapStoreFromAdming.codeMapList : codeMapStoreFromMobile.codeMapList
  const getValueToName = (category: CodeMapCategory | CodeMapCategory[], value: string = '') =>
    codeMapList
      ?.filter(codeMap =>
        Array.isArray(category) ? (category as string[]).includes(codeMap.category) : codeMap.category === category
      )
      .find(codeMap => codeMap.value === value)?.name

  return { getValueToName }
}

export const useGetCodeMapCategorySystemValue = ({
  category = CodeMapCategory.SystemParams,
  reserve1,
  locateAt,
}: {
  category?: string
  reserve1: string
  locateAt: CodeMapTokenWithLocate
}): string => {
  const codeMapList =
    locateAt === CodeMapTokenWithLocate.Admin ? codeMapStoreFromAdming.codeMapList : codeMapStoreFromMobile.codeMapList
  const categoryData = codeMapList.filter(item => item.category === category)
  const reserve1Data = categoryData.filter(item => item.reserve1 === reserve1)

  const value = reserve1Data.at(0)?.value || ''

  return value
}

export const errorHandler = async (res: Response) => {
  const errorData: ErrorData = await res.json()
  const { status, detail, message } = errorData
  throw new Error(`${detail ?? message}, 錯誤代碼：${status}`)
}
